function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { arrayOf, node, oneOf, oneOfType, string } from 'prop-types';
import React from 'react';
import { CheckedFull, AlertCircle, AlertTriangle } from '@gympass/yoga-icons';
import Icon from '../../Icon';
import Box from '../../Box';
import Text from '../../Text';
import { Actions, Content, Title, PrimaryButton, SecondaryButton, TextContainer } from './StyledFeedback';
var ICON_SIZE = 64;
var VARIANT_ICONS = {
  success: {
    as: CheckedFull,
    fill: 'hope'
  },
  informative: {
    as: AlertCircle,
    fill: 'relax'
  },
  attention: {
    as: AlertTriangle,
    fill: 'brandingVerve'
  }
};

function isChildFromComponent(child, component) {
  return child.type.displayName === component.displayName;
}

function Feedback(_ref) {
  var variant = _ref.variant,
      title = _ref.title,
      description = _ref.description,
      children = _ref.children;
  var iconProps = VARIANT_ICONS[variant];
  var primaryButton;
  var secondaryButton;
  var titleElement = /*#__PURE__*/React.createElement(Title, null, title);

  function defineCompoundComponents() {
    React.Children.forEach(children, function (child) {
      if (isChildFromComponent(child, PrimaryButton)) primaryButton = child;
      if (isChildFromComponent(child, SecondaryButton)) secondaryButton = child;
      if (isChildFromComponent(child, Title)) titleElement = child;
    });
  }

  defineCompoundComponents();
  return /*#__PURE__*/React.createElement(Box, {
    ph: "medium",
    pv: "xxlarge",
    minHeight: "100%",
    width: "100%",
    display: "flex",
    alignItems: "flex-end",
    bg: "white"
  }, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Icon, _extends({}, iconProps, {
    size: ICON_SIZE,
    mb: "large",
    "data-testid": "feedback-icon"
  })), /*#__PURE__*/React.createElement(TextContainer, null, titleElement, /*#__PURE__*/React.createElement(Text, {
    mt: "small",
    color: "deep"
  }, description)), /*#__PURE__*/React.createElement(Actions, {
    mt: "xxxlarge"
  }, primaryButton, secondaryButton)));
}

Feedback.propTypes = {
  variant: oneOf(Object.keys(VARIANT_ICONS)).isRequired,
  title: string,
  description: string.isRequired,
  children: oneOfType([arrayOf(node), node])
};
Feedback.defaultProps = {
  title: undefined,
  children: undefined
};
export default Feedback;